<template>
  <div class="default-wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Default',
}
</script>
